import { createContext, useContext, useEffect, useState } from "react";
import { isTokenValid, getTokenRemainingTime } from "../utils/auth";
import { localhostKey, pageRoute } from "../utils/common";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem(localhostKey.token));

  // Load user on app start
  useEffect(() => {
    const storedToken = localStorage.getItem(localhostKey.token);
    if (storedToken && isTokenValid(storedToken)) {
      setToken(storedToken);
      setUser({ token: storedToken });
      autoLogout(storedToken);
    } else {
      logout();
    }
  }, []);

  const login = (jwtToken) => {
    localStorage.setItem(localhostKey.token, jwtToken);
    setToken(jwtToken);
    setUser({ token: jwtToken });
    autoLogout(jwtToken);
  };

  const logout = () => {
    localStorage.removeItem(localhostKey.token);
    setUser(null);
    setToken(null);
  };

  const autoLogout = (jwtToken) => {
    const remainingTime = getTokenRemainingTime(jwtToken);
    setTimeout(() => {
      logout();
      window.location.href = pageRoute.login; 
    }, remainingTime);
  };

  const isAuthenticated = !!token && isTokenValid(token);

  return (
    <AuthContext.Provider value={{ user, token, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
